/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Utils
import { get } from 'lodash';

// Components
import AuthContainer from './AuthContainer.vue';
import BaseInput from 'shared/ui/components/form-components/BaseInput.vue';
import Checkbox from 'shared/ui/components/form-components/Checkbox.vue';
import HorizontalDivider from 'shared/ui/components/HorizontalDivider.vue';

const __vue_script__ = {
    name: 'Login',

    components: {
        AuthContainer,
        BaseInput,
        Checkbox,
        HorizontalDivider,
    },

    data() {
        return {
            clauses: {},
            clausesLabel: {},
            email: null,
            errorMessage: null,
            password: null,
            showClauses: false,
            showResetPassword: false,
            submitting: false
        };
    },

    created() {
        this.clauses = {};
        this.clausesLabel = {};

        for (const clause of this.$const.USER_MANDATORY_CLAUSES) {
            this.clauses[clause] = false;
            this.clausesLabel[clause] = this.$i18n.t(`clauses.${clause}`, this.$const.USER_MANDATORY_CLAUSES_I18N_REPLACEMENTS[clause]);
        }
    },

    methods: {

        /**
         * Performs the login
         */
        async authenticate() {
            try {
                this.reset();
                console.info('[Login] Logging in...');
                this.submitting = true;

                const data = await this.$services.session.login(this.email, this.password, this.showClauses ? this.clauses : undefined);
                console.info('[Login] Login successful:', data);
                this.showClauses = false;

                if (data.warning) {
                    this.$notify({
                        group: 'flashes',
                        text: data.warning,
                        type: 'warning',
                        duration: -1
                    });
                }


                if (data.mfa_token) {
                    this.$router.push({ path: this.$const.ROUTE_LOGIN_WITH_MFA, query: { mfa_token: data.mfa_token, phone_digits: data.phone_digits, remember: !!data.prefill_remember } });
                } else if (data.phone_request_token) {
                    this.$router.push({ path: this.$const.ROUTE_MFA_PHONE, query: { phone_request_token: data.phone_request_token } });
                } else {
                    this.$services.router.redirectToHome();
                }

            } catch (error) {
                const err = get(error, 'response.data.error', {});
                console.info('[Login] An error occurred:', err, error);

                if (err.user_not_active) {
                    return this.$router.push({
                        path: this.$const.ROUTE_VALIDATE_ACCOUNT,
                        query: { email: this.email }
                    });
                }

                let errorCode = 'login_failed';
                let errorParams = [];

                if (err.expired) {
                    errorCode = 'password_expired';
                    this.showResetPassword = true;

                } else if (err.deactivated) {
                    errorCode = 'account_deactivated';

                } else if (err.clauses) {
                    errorCode = 'clause_not_accepted';
                    this.showClauses = true;

                } else if (err.password_login_disabled) {
                    errorCode = 'password_login_disabled';
                    errorParams = [err.sso];

                } else if (err.account_locked) {
                    errorCode = 'account_locked';
                    this.showResetPassword = true;

                } else if (err.mfa_client_error) {
                    errorCode = 'mfa_client_error';
                }

                this.errorMessage = this.$i18n.t(`login.errors.${errorCode}`, errorParams);

            } finally {
                this.submitting = false;
            }
        },

        /**
         * Resets all the errors and component's default
         */
        reset() {
            this.errorMessage = null;
            this.showResetPassword = false;
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('auth-container',[_c('div',{staticClass:"login-container"},[_c('validation-observer',{attrs:{"slim":true},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var handleSubmit = ref.handleSubmit;
return [_c('form',{staticClass:"login",attrs:{"aria-label":_vm.$t('login.forms.login')},on:{"submit":function($event){$event.preventDefault();return handleSubmit(_vm.authenticate)}}},[(_vm.errorMessage)?_c('div',{staticClass:"alert alert-info"},[_c('p',[_vm._v(_vm._s(_vm.errorMessage))]),(_vm.showResetPassword)?[_c('router-link',{staticClass:"reset-link",attrs:{"to":_vm.$const.ROUTE_SEND_RESET_TOKEN}},[_vm._v(_vm._s(_vm.$t('login.links.reset_password'))+".")])]:_vm._e()],2):_vm._e(),_c('validation-provider',{attrs:{"rules":"required","slim":true,"name":"email"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('base-input',{staticClass:"username",attrs:{"placeholder":_vm.$t('login.forms.email'),"type":"email","name":"email","errors":errors,"autocomplete":"email"},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}})]}}],null,true)}),_c('validation-provider',{attrs:{"rules":"required","slim":true,"name":"password"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('base-input',{staticClass:"password",attrs:{"placeholder":_vm.$t('login.forms.password'),"type":"password","name":"password","errors":errors,"autocomplete":"current-password"},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}})]}}],null,true)}),_vm._l((_vm.$const.USER_MANDATORY_CLAUSES),function(clause){return (_vm.showClauses)?_c('validation-provider',{key:clause,attrs:{"rules":{ required: { allowFalse: false } },"slim":true,"name":clause},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('checkbox',{staticClass:"clause",attrs:{"label":_vm.clausesLabel[clause],"name":clause,"errors":errors},model:{value:(_vm.clauses[clause]),callback:function ($$v) {_vm.$set(_vm.clauses, clause, $$v)},expression:"clauses[clause]"}})]}}],null,true)}):_vm._e()}),_c('div',{staticClass:"actions"},[_c('div',{staticClass:"action"},[_c('router-link',{staticClass:"forgot-password",attrs:{"to":_vm.$const.ROUTE_SEND_RESET_TOKEN}},[_vm._v(_vm._s(_vm.$t('login.links.forgot_password')))])],1),_c('div',{staticClass:"action"},[_c('button',{staticClass:"btn btn-login",attrs:{"disabled":_vm.submitting}},[_vm._v(_vm._s(_vm.$t('login.forms.actions.sign_in' )))])])])],2)]}}])}),_c('horizontal-divider',{staticClass:"login-divider"},[_vm._v(_vm._s(_vm.$t("base.or")))]),_c('div',{staticClass:"actions"},[_c('div',{staticClass:"action"},[_c('router-link',{staticClass:"btn btn-login-alt",attrs:{"to":_vm.$const.ROUTE_LOGIN_WITH_SSO}},[_vm._v(_vm._s(_vm.$t('login.links.login_with_sso' )))])],1)])],1)])}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "Login.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__